// udp-container-query-grid.tsx
import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'udp-container-query-grid',
  styleUrl: 'udp-container-query-grid.css',
  shadow: true,
})
export class UdpContainerQueryGrid {
  // Breakpoints for different container sizes
  @Prop() columns?: { [breakpoint: number]: number } = {
    0: 1, // Default: single column
    400: 2, // Small: 2 columns
    600: 3, // Medium: 3 columns
    800: 4, // Large: 4 columns
  };

  @Prop() gaps?: { [breakpoint: number]: number } = {
    0: 1, // Default: 1rem gap
    400: 1.5, // Small: 1.5rem gap
    600: 2, // Medium: 2rem gap
    800: 2.5, // Large: 2.5rem gap
  };

  render() {
    // Convert our columns and gaps into container query styles
    const queries = {};
    const breakpoints = new Set([...Object.keys(this.columns), ...Object.keys(this.gaps)].map(Number));

    Array.from(breakpoints)
      .sort((a, b) => b - a)
      .forEach(breakpoint => {
        queries[breakpoint] = {
          ...(this.columns[breakpoint] && {
            'grid-template-columns': `repeat(${this.columns[breakpoint]}, 1fr)`,
          }),
          ...(this.gaps[breakpoint] && {
            gap: `${this.gaps[breakpoint]}rem`,
          }),
        };
      });

    return (
      <Host>
        <udp-container-query queries={queries}>
          <div class="grid-container">
            <slot></slot>
          </div>
        </udp-container-query>
        <style>{`
          .grid-container {
            display: grid;
            grid-template-columns: repeat(${this.columns[0]}, 1fr);
            gap: ${this.gaps[0]}rem;
            width: 100%;
          }
        `}</style>
      </Host>
    );
  }
}
